export default {"src":"/_next/static/media/eveningStandard.e38a6f62.svg","height":30,"width":249,"blurWidth":0,"blurHeight":0};